import React, { useState } from "react";
import { useApp } from "@/context/AppContext";
import { api, apiError } from "@/lib/api";
import { toast } from "sonner";
import { UserPlus, Loader2 } from "lucide-react";

export const UsersManager = ({ rows, reload }) => {
  const { t, user } = useApp();
  const a = t.admin;
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [saving, setSaving] = useState(false);
  const inputCls = "px-3 py-2 rounded-lg border border-slate-200 bg-white focus:border-tigris outline-none text-sm";

  const addStaff = async (e) => {
    e.preventDefault(); setSaving(true);
    try { await api.post("/admin/staff", form); toast.success(a.staffAdded); setForm({ name: "", email: "", password: "" }); reload(); }
    catch (err) { toast.error(apiError(err.response?.data?.detail) || err.message); }
    finally { setSaving(false); }
  };
  const setRole = async (u, role) => {
    try { await api.patch(`/admin/users/${u.id}/role`, { role }); toast.success(a.updated); reload(); }
    catch (err) { toast.error(apiError(err.response?.data?.detail)); }
  };

  return (
    <div>
      <form onSubmit={addStaff} data-testid="add-staff-form" className="bg-white rounded-2xl border border-slate-100 shadow-sm p-4 mb-4 flex flex-wrap items-end gap-3">
        <div className="flex items-center gap-2 font-bold text-slate-700 text-sm w-full sm:w-auto"><UserPlus size={16} className="text-gold" /> {a.addStaff}</div>
        <input data-testid="staff-name" className={inputCls} placeholder={a.name} value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} required />
        <input data-testid="staff-email" type="email" dir="ltr" className={inputCls} placeholder={a.email} value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} required />
        <input data-testid="staff-password" type="password" dir="ltr" className={inputCls} placeholder={a.password} minLength={6} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} required />
        <button type="submit" disabled={saving} data-testid="staff-submit" className="btn-primary px-4 py-2 rounded-lg text-sm font-bold flex items-center gap-2">{saving ? <Loader2 size={16} className="animate-spin" /> : a.add}</button>
      </form>

      <div className="bg-white rounded-2xl border border-slate-100 shadow-sm overflow-x-auto">
        <table className="w-full text-sm" data-testid="admin-table-users">
          <thead className="bg-slate-50 text-slate-500 text-xs"><tr>
            {[a.name, a.email, a.role, a.provider, a.date].map((h, i) => <th key={i} className="px-4 py-3 text-start font-semibold">{h}</th>)}
          </tr></thead>
          <tbody className="divide-y divide-slate-100">
            {rows.map((u) => (
              <tr key={u.id} data-testid={`user-row-${u.id}`} className="hover:bg-slate-50/60">
                <td className="px-4 py-3 font-semibold">{u.name}</td>
                <td className="px-4 py-3" dir="ltr">{u.email}</td>
                <td className="px-4 py-3">
                  {u.role === "admin" || u.id === user.id ? (
                    <span className="text-xs font-bold px-2 py-1 rounded-full bg-gold/15 text-gold">{a.roles.admin}</span>
                  ) : (
                    <select data-testid={`user-role-${u.id}`} className="text-xs border border-slate-200 rounded-lg px-2 py-1.5 bg-white" value={u.role} onChange={(e) => setRole(u, e.target.value)}>
                      <option value="customer">{a.roles.customer}</option>
                      <option value="staff">{a.roles.staff}</option>
                    </select>
                  )}
                </td>
                <td className="px-4 py-3 text-xs">{u.auth_provider || "email"}</td>
                <td className="px-4 py-3 text-xs">{u.created_at?.slice(0, 10)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
